import styled from 'styled-components';

export const StyledOpener = styled.button`
  display: none;
  position: relative;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.headerText};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  &:hover {
    color: ${({ theme }) => theme.headerAccent};
  }
  span {
    position: absolute;
    left: 13px;
    width: 18px;
    height: 2px;
    border-radius: 1px;
    background: currentColor;
    transition: transform 160ms ease, top 160ms ease, opacity 160ms ease;
  }
  span:nth-child(1) {
    top: 15px;
  }
  span:nth-child(2) {
    top: 21px;
  }
  span:nth-child(3) {
    top: 27px;
  }
  &[data-open='true'] span:nth-child(1) {
    top: 21px;
    transform: rotate(45deg);
  }
  &[data-open='true'] span:nth-child(2) {
    opacity: 0;
  }
  &[data-open='true'] span:nth-child(3) {
    top: 21px;
    transform: rotate(-45deg);
  }
  @media (prefers-reduced-motion: reduce) {
    span {
      transition: none;
    }
  }
  @media screen and (max-width: 1199px) {
    display: block;
  }
`;
